import { useState, useEffect } from "react";
import { useOrderDraft } from "../context/OrderDraftContext";
import { useNavigate } from "react-router-dom";
import { PATHS } from "../app/paths";

export const usePatientForm = () => {
  const { patientName, setPatientName, birthDate, setBirthDate, cpf, setCpf, sexo, setSexo, documentNumber, setDocumentNumber, convenio, setConvenio, documentValidity, setDocumentValidity } = useOrderDraft();
  const [status, setStatus] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    setStatus(!(patientName && birthDate && cpf && sexo && documentNumber && convenio && documentValidity));
  }, [patientName, birthDate, cpf, sexo, documentNumber, convenio, documentValidity]);

  const makeRedirect = () => {
    if (!status) {
      setStatus(true);
      navigate(PATHS.newOrder);
    }
  };

  return {
    patientName,
    setPatientName,
    birthDate,
    setBirthDate,
    cpf,
    setCpf,
    sexo,
    setSexo,
    documentNumber,
    setDocumentNumber,
    convenio,
    setConvenio,
    documentValidity,
    setDocumentValidity,
    status,
    makeRedirect,
  };
};
